import './styles/ProcessLogin.scss';

import { useQuery } from '@apollo/client';
import { Backdrop, CircularProgress, Grid } from '@mui/material';

import { ReactElement, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import USER_QUERY from 'gql/queries/currentUser.gql';

import { translations } from 'locales/i18n';

interface Props {
  query?: any;
}

export default function ProcessLogin({ query }: Props): ReactElement {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state } = useLocation();

  const { refetch: getUser } = useQuery<any, any>(USER_QUERY, {
    context: { clientName: 'federation' },
    skip: true
  });

  useEffect(() => {
    const handleLogin = async () => {
      await getUser();
      if (state) {
        navigate(state?.from?.pathname, { replace: true });
        window.location.href = state?.from?.pathname;
      } else {
        const locationAfterLogin = localStorage.getItem('redirect-after-login');
        if (locationAfterLogin) {
          setTimeout(() => {
            localStorage.removeItem('redirect-after-login');
            navigate(locationAfterLogin, { replace: true });
            window.location.href = locationAfterLogin;
          }, 1000);
        } else {
          navigate('/', { replace: true });
          window.location.href = '/';
        }
      }
    };
    handleLogin();
  });

  return (
    <Backdrop open>
      <Grid container className="process-login">
        <Grid container justifyContent="center">
          <CircularProgress color="primary" />
        </Grid>
        <Grid container className="process-login__message" justifyContent="center">
          {t(translations.pages.login.processLogin())}
        </Grid>
      </Grid>
    </Backdrop>
  );
}
